/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ColumnInfoFragmentGQLType = (
  { __typename?: 'ColumnInfo' }
  & Pick<Types.ColumnInfoGQLType, 'name' | 'required' | 'type' | 'description' | 'examples' | 'defaultValue'>
);

export type RequiredDataTapeFragmentGQLType = (
  { __typename?: 'RequiredDataTape' }
  & Pick<Types.RequiredDataTapeGQLType, 'externalFilename' | 'artifactType' | 'artifactSlug' | 'artifactId' | 'validCreditFacilityIds' | 'loanProductSlug' | 'currentFileVersion' | 'currentReportingDate' | 'progressSummary'>
  & { columns: Array<(
    { __typename?: 'ColumnInfo' }
    & ColumnInfoFragmentGQLType
  )> }
);

export type RequiredXlsxTapeFragmentGQLType = (
  { __typename?: 'RequiredXlsxTape' }
  & Pick<Types.RequiredXlsxTapeGQLType, 'externalFilename' | 'artifactType' | 'artifactSlug' | 'artifactId' | 'validCreditFacilityIds' | 'loanProductSlug' | 'currentFileVersion' | 'currentReportingDate' | 'progressSummary'>
  & { valueFieldGroups: Array<(
    { __typename?: 'XlsxValueFieldGroup' }
    & Pick<Types.XlsxValueFieldGroupGQLType, 'dataTapeSlug'>
    & { columns: Array<(
      { __typename?: 'ColumnInfo' }
      & Pick<Types.ColumnInfoGQLType, 'sheetName' | 'cellAddress'>
      & ColumnInfoFragmentGQLType
    )> }
  )>, tapeFieldGroups: Array<(
    { __typename?: 'XlsxTapeFieldGroup' }
    & Pick<Types.XlsxTapeFieldGroupGQLType, 'dataTapeSlug' | 'sheetName' | 'headerRange'>
    & { columns: Array<(
      { __typename?: 'ColumnInfo' }
      & ColumnInfoFragmentGQLType
    )> }
  )> }
);

export type GetRequiredDataTapesQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  omitOrgProvidedInputGraphs: Types.Scalars['Boolean'];
  reportingDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetRequiredDataTapesQueryGQLType = (
  { __typename?: 'Query' }
  & { getRequiredDataTapes: (
    { __typename?: 'RequiredDataTapes' }
    & { requiredDataTapesGroupings: Array<(
      { __typename?: 'RequiredDataTapeGrouping' }
      & Pick<Types.RequiredDataTapeGroupingGQLType, 'latestReportingDate'>
      & { requiredDataTapes: Array<(
        { __typename?: 'RequiredDataTape' }
        & RequiredDataTapeFragmentGQLType
      )>, requiredXlsxTapes: Array<(
        { __typename?: 'RequiredXlsxTape' }
        & RequiredXlsxTapeFragmentGQLType
      )>, requiredCashBalances: Array<(
        { __typename?: 'RequiredCashBalance' }
        & Pick<Types.RequiredCashBalanceGQLType, 'externalFilename' | 'creditFacilityId' | 'artifactType' | 'artifactSlug' | 'artifactId' | 'currentFileVersion' | 'currentReportingDate' | 'accountTypesWithConnectionProvider'>
        & { columns: Array<(
          { __typename?: 'ColumnInfo' }
          & Pick<Types.ColumnInfoGQLType, 'name' | 'required' | 'type' | 'description' | 'examples' | 'defaultValue'>
        )> }
      )> }
    )> }
  ) }
);

export type GetRequiredDataTapesForVerificationQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetRequiredDataTapesForVerificationQueryGQLType = (
  { __typename?: 'Query' }
  & { getRequiredDataTapesForVerification: (
    { __typename?: 'RequiredDataTapes' }
    & { requiredDataTapesGroupings: Array<(
      { __typename?: 'RequiredDataTapeGrouping' }
      & Pick<Types.RequiredDataTapeGroupingGQLType, 'latestReportingDate'>
      & { requiredDataTapes: Array<(
        { __typename?: 'RequiredDataTape' }
        & RequiredDataTapeFragmentGQLType
      )>, requiredXlsxTapes: Array<(
        { __typename?: 'RequiredXlsxTape' }
        & RequiredXlsxTapeFragmentGQLType
      )> }
    )> }
  ) }
);

export const ColumnInfoFragmentDocGQLType = gql`
    fragment ColumnInfo on ColumnInfo {
  name
  required
  type
  description
  examples
  defaultValue
}
    `;
export const RequiredDataTapeFragmentDocGQLType = gql`
    fragment RequiredDataTape on RequiredDataTape {
  externalFilename
  artifactType
  artifactSlug
  artifactId
  validCreditFacilityIds
  loanProductSlug
  currentFileVersion
  currentReportingDate
  progressSummary
  columns {
    ...ColumnInfo
  }
}
    ${ColumnInfoFragmentDocGQLType}`;
export const RequiredXlsxTapeFragmentDocGQLType = gql`
    fragment RequiredXlsxTape on RequiredXlsxTape {
  externalFilename
  artifactType
  artifactSlug
  artifactId
  validCreditFacilityIds
  loanProductSlug
  currentFileVersion
  currentReportingDate
  progressSummary
  valueFieldGroups {
    dataTapeSlug
    columns {
      ...ColumnInfo
      sheetName
      cellAddress
    }
  }
  tapeFieldGroups {
    dataTapeSlug
    sheetName
    headerRange
    columns {
      ...ColumnInfo
    }
  }
}
    ${ColumnInfoFragmentDocGQLType}`;
export const GetRequiredDataTapesDocumentGQLType = gql`
    query getRequiredDataTapes($organizationId: UUID!, $omitOrgProvidedInputGraphs: Boolean!, $reportingDate: FullDateStr) {
  getRequiredDataTapes(
    organizationId: $organizationId
    reportingDate: $reportingDate
    omitOrgProvidedInputGraphs: $omitOrgProvidedInputGraphs
  ) {
    requiredDataTapesGroupings {
      latestReportingDate
      requiredDataTapes {
        ...RequiredDataTape
      }
      requiredXlsxTapes {
        ...RequiredXlsxTape
      }
      requiredCashBalances {
        externalFilename
        creditFacilityId
        artifactType
        artifactSlug
        artifactId
        currentFileVersion
        currentReportingDate
        columns {
          name
          required
          type
          description
          examples
          defaultValue
        }
        accountTypesWithConnectionProvider
      }
    }
  }
}
    ${RequiredDataTapeFragmentDocGQLType}
${RequiredXlsxTapeFragmentDocGQLType}`;

/**
 * __useGetRequiredDataTapesQuery__
 *
 * To run a query within a React component, call `useGetRequiredDataTapesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredDataTapesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredDataTapesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      omitOrgProvidedInputGraphs: // value for 'omitOrgProvidedInputGraphs'
 *      reportingDate: // value for 'reportingDate'
 *   },
 * });
 */
export function useGetRequiredDataTapesQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>(GetRequiredDataTapesDocumentGQLType, options);
      }
export function useGetRequiredDataTapesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>(GetRequiredDataTapesDocumentGQLType, options);
        }
export type GetRequiredDataTapesQueryHookResult = ReturnType<typeof useGetRequiredDataTapesQuery>;
export type GetRequiredDataTapesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRequiredDataTapesLazyQueryGQLType>;
export type GetRequiredDataTapesQueryResultGQLType = Apollo.QueryResult<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>;
export const GetRequiredDataTapesForVerificationDocumentGQLType = gql`
    query getRequiredDataTapesForVerification($creditFacilityId: UUID!) {
  getRequiredDataTapesForVerification(creditFacilityId: $creditFacilityId) {
    requiredDataTapesGroupings {
      latestReportingDate
      requiredDataTapes {
        ...RequiredDataTape
      }
      requiredXlsxTapes {
        ...RequiredXlsxTape
      }
    }
  }
}
    ${RequiredDataTapeFragmentDocGQLType}
${RequiredXlsxTapeFragmentDocGQLType}`;

/**
 * __useGetRequiredDataTapesForVerificationQuery__
 *
 * To run a query within a React component, call `useGetRequiredDataTapesForVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredDataTapesForVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredDataTapesForVerificationQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetRequiredDataTapesForVerificationQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>(GetRequiredDataTapesForVerificationDocumentGQLType, options);
      }
export function useGetRequiredDataTapesForVerificationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>(GetRequiredDataTapesForVerificationDocumentGQLType, options);
        }
export type GetRequiredDataTapesForVerificationQueryHookResult = ReturnType<typeof useGetRequiredDataTapesForVerificationQuery>;
export type GetRequiredDataTapesForVerificationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRequiredDataTapesForVerificationLazyQueryGQLType>;
export type GetRequiredDataTapesForVerificationQueryResultGQLType = Apollo.QueryResult<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>;